<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Bulk Edit Student Info</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
          <v-file-input placeholder="CSV of student data" prepend-icon="mdi-file" label="Student Data" show-size flat
            rounded outlined dense v-model="file"></v-file-input>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
          <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/EditBulkInformation.csv">
            <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
              class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
              Download import CSV format
              <v-icon right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
      </v-row>
      <v-col cols="12" sm="12" md="12">
        <template v-if="load == true">
          <v-data-table dense :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable"
            :search="search" :loading="output_load">
            <template v-slot:item.status="{ item }">
              <span v-if="item.status">
                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
              </span>
              <span v-else>
                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
              </span>
            </template>
          </v-data-table>
        </template>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },

  /*
      Defines the data used by the component
    */
  data() {
    return {
      snackbar_msg: "",
      color: "",
      snackbar: false,
      // extraBreadcrumbItems: [
    

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      search: "",
      file: null,
      statuslist: "",
      load: false,
      loading3: false,
      search: "",
      headers: [
        { text: "Learner Id", value: "learner" },
        { text: "Status", value: "status" },
      ],
      output_load: false,
    };
  },

  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    submitFile() {
      if (this.file == null) {
        alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        //console.log(this.file.size)
        formData.append("file", this.file);

        //console.log(formData)
        axios
          .post("Admission/importBulkEditOtherInfo", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.statuslist.length != 0) {
                this.statuslist = res.data.statuslist;
                this.load = true;
                this.showSnackbar("#4caf50", "Records updated successfully..."); // show snackbar on success
              } else {
                this.statuslist = [];
                this.load = true;
                this.showSnackbar("#b71c1c", "The CSV file is empty!"); // show snackbar on success
              }
              // this.statuslist = res.data.statuslist;
              // this.load = true;
              // this.showSnackbar("#4caf50", "Records updated successfully..."); // show snackbar on success
              //this.getsubjectoffering()
              // Object.assign(this.courselist[this.editedIndex], this.editedItem);
            }
          })
          .catch(function () {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction

    /*
        Handles a change on the file upload
      */
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}

.downbtn:hover {
    color: white !important;
  }

.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
